import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Table } from '@tmapy/style-guide';

import './DocList.scss';

import { DocListItemDtmKad } from './DocListItemDtmKad';
import { docListMessages } from './docsMessages';
import { ResponsiblePersonHeader } from './ResponsiblePersonColumn';
import { LoadNextItemsBar } from '../../app/components/LoadNextItemsBar';
import { QUERY_STATE } from '../../constants';
import type { DocListResponse } from '../../openapi/types';

export type DocListDtmKadProps = {
  docList: DocListResponse[];
  queryState: QUERY_STATE;
  docCount: number | undefined;
  handleNextDocsBtnClick: () => void;
};

export const DocListDtmKad: React.FC<DocListDtmKadProps> = ({
  docList,
  queryState,
  docCount,
  handleNextDocsBtnClick,
}) => {
  return (
    <div className='sg-u-box sg-a-px-2 sg-a-pb-2 sg-u-vs-2'>
      <div className='sg-a-mx--2'>
        <Table isClickable>
          <thead>
            <tr>
              <th className='sg-a-ta-c'>
                <FormattedMessage {...docListMessages.docListColumnState} />
                <br />
                <FormattedMessage {...docListMessages.docListColumnNumber} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnName} />
                <br />
                <FormattedMessage {...docListMessages.docListColumnDescription} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnPrejimkaType} />
              </th>
              <th className='sg-a-ta-r'>
                <FormattedMessage {...docListMessages.docListColumnDtmkCreated} />
                <>
                  <br />
                  <span className='dmx-u-c-cta-red'>
                    <FormattedMessage {...docListMessages.docListColumnClosed} />
                  </span>
                </>
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnAuthor} />
                <br />
                <span className='dmx-u-c-cta-gray'>
                  <FormattedMessage {...docListMessages.docListColumnGeodesist} />
                </span>
              </th>
              <ResponsiblePersonHeader />
              <th />
            </tr>
          </thead>
          <tbody>
            {docList.map((docItem) => (
              <DocListItemDtmKad key={docItem.id} {...docItem} />
            ))}
          </tbody>
        </Table>
      </div>
      <LoadNextItemsBar
        count={docList.length}
        total={docCount!}
        queryState={queryState}
        onNextBtnClick={handleNextDocsBtnClick}
      />
    </div>
  );
};
